import type { Question } from '../types/questionnaire';

export const QUESTIONS: Question[] = [
  {
    id: 1,
    field: 'business_stage',
    question: "What stage is your business?",
    hint: 'Understanding your growth phase helps us benchmark your metrics appropriately.',
    type: 'single',
    options: [
      'Pre-revenue',
      'Early Stage (<$100K ARR)',
      'Growth ($100K-$1M ARR)',
      'Scale ($1M-$10M ARR)',
      'Mature / Plateau ($10M+ ARR)',
    ],
  },
  {
    id: 2,
    field: 'challenges',
    question: 'What are your biggest business challenges?',
    hint: "Select all that apply — we'll prioritize recommendations accordingly.",
    type: 'multi',
    options: [
      'Revenue plateau or decline',
      'Customer churn',
      'Rising acquisition costs',
      'Data & attribution gaps',
      'Pricing strategy',
      'Market expansion',
    ],
  },
  {
    id: 3,
    field: 'revenue_range',
    question: 'What is your monthly revenue range?',
    hint: 'This helps calibrate budget recommendations to your scale.',
    type: 'single',
    options: [
      '$0 - $10K',
      '$10K - $50K',
      '$50K - $250K',
      '$250K - $1M',
      '$1M+',
    ],
  },
  {
    id: 4,
    field: 'success_goal',
    question: 'What does success look like in 6 months?',
    hint: 'Describe your goals so we can align the strategic roadmap.',
    type: 'text',
    placeholder: 'e.g., Stabilize subscriber base, grow trials 30%, launch enterprise tier...',
  },
];
